<template>
  <div class="connection_container" v-if="connection.monitoring">
    <div class="connection-redirect toasted toasted-primary error" v-if="connection.redPings >= 1">
      <!--TODO: show red box with info about connection loss and redirect-->
      Achtung! Verbindung schlecht: Sie werden gleich ausgeloggt
    </div>
    <feather
      type="wifi"
      :class="{
        'connection-red': connection.connectionRating == 'red',
        'connection-yellow': connection.connectionRating == 'yellow',
        'connection-green': connection.connectionRating == 'green',
      }"
      @click.prevent="openConnModal"
    ></feather>
    <b-modal id="connectionModal">
      <div class="connection-rating" v-if="connection.connectionRating">
        <div class="iam-center">
            <feather
              type="wifi"
              :class="{
                'connection-red': connection.connectionRating == 'red',
                'connection-yellow': connection.connectionRating == 'yellow',
                'connection-green': connection.connectionRating == 'green',
              }"
              size="80"
            ></feather>
        </div>
      </div>
      <ul class="connection-info-list" v-if="connection.projectInfo && connection.userInfo">
        <li>
          <div>Verbindungsqualität</div>
          <div>{{ connection.lastPingResult }}ms</div>
        </li>
        <li>
          <div>Benutzer</div>
          <div>{{ connection.userInfo.first_name }} {{ connection.userInfo.last_name }}</div>
        </li>
        <li v-if="isAdmin">
          <div>Operating System</div>
          <div>{{ connection.projectInfo.os.type }}</div>
        </li>
        <li v-if="isAdmin">
          <div>Directus Version</div>
          <div>{{ connection.projectInfo.directus.version }}</div>
        </li>
      </ul>
      <template slot="modal-header">
        <h5>Verbindungsinformationen</h5>
      </template>
    </b-modal>
    <b-modal id="connectionRedirectModal">

    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "connection",
  data() {
    return {};
  },
  components: {},
  async created() {
    if (!this.connection.monitoring) { await this.$store.dispatch("auth/startConnectionMonitoring");}
  },
  computed: {
    ...mapGetters({
      auth: "auth/isAuth",
      isAdmin: "auth/isAdmin",
      apiSettings: "auth/apiSettings",
      connection: "auth/connection",
    }),
  },
  methods: {
    openConnModal() {
      this.$bvModal.show("connectionModal");
    },
    closeModal() {
      this.$bvModal.hide("connectionModal");
    },
    connectionLoss() {
      this.$bvModal.show("connectionRedirectModal");
    }
  },
};
</script>

<style>
.connection-info-list li {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  position: relative;
  top: 0px;
}

.connection-red,
.connection-red svg {
  color: red !important;
}

.connection-medium,
.connection-medium svg {
  color: yellow !important;
}

.connection-green,
.connection-green svg {
  color: green !important;
}

.iam-center {
   display:flex!important;
   justify-content:center;
}

.iam-center i {
    display:block;
}

.connection-redirect {
  display: flex;
  align-items: center;
}

.connection_container {
  display: flex;
  align-items: center;
  gap: 20px;
  position: relative;
  top: -4px;
}

.error {
  margin: auto !important;
}
</style>
